<svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  @for (p of paths(); track $index) {
    <path [attr.d]="p" />
  }
</svg>
